import actions from './actions'
import mutations from './mutations'

const payments = {
    namespaced: true,
    state: {
        type: 'admin',
        email: null,
        activeLeader: null
    },
    mutations,
    actions
}

export default payments
